import { mapControl } from '@/constants';
import { dropIcon } from '@/lib/map-control/marker/icon';
import Marker from './Marker';
import { isIncludedCurrentFilter } from '../helper';
export default class DropMarker extends Marker {
    #type = 'drop';
    startLat;
    startLng;
    endLat;
    endLng;
    isShow;
    orderId;
    storeId;
    statusCode;
    isDelayedState;
    icon;
    origin;
    allocatedWorkerCode;
    constructor({ startLat, startLng, endLat, endLng, orderData, isShow, }, naver, hubControlMap) {
        super(naver, hubControlMap);
        const { orderId: id, storeId, allocatedWorkerCode, statusCode, isDelayedState, } = orderData;
        this.startLat = startLat;
        this.startLng = startLng;
        this.endLat = endLat;
        this.endLng = endLng;
        this.isShow = isShow;
        this.id = id;
        this.orderId = id;
        this.storeId = storeId;
        this.allocatedWorkerCode = allocatedWorkerCode;
        this.latLng = [
            endLat,
            endLng,
        ];
        this.statusCode = statusCode;
        this.isDelayedState = isDelayedState;
        this.origin = this.mapControlState.orderList[this.orderId];
        this.icon = dropIcon({
            naver: this.naver,
            orderId: id,
            isDelayedState,
        });
    }
    set line(value) {
        this.naverMarker.line = value;
    }
    get line() {
        return this.naverMarker.line;
    }
    deleteMarker() {
        this.hubControlMap.mapMarkerList.drops.deleteMarker(this.orderId);
    }
    getAllocatedWorker() {
        const workerCode = this.origin.allocatedWorkerCode;
        return this.hubControlMap.mapMarkerList.workers.getMarker(workerCode);
    }
    getMyStore() {
        return this.hubControlMap.mapMarkerList.stores.getMarker(this.storeId);
    }
    setLineNormal() {
        this.line.setOptions({
            strokeWeight: 4,
        });
    }
    setLineBold() {
        this.line.setOptions({
            strokeWeight: 8,
        });
    }
    /**
     * 라인 색상 변경
     * @param statusCode
     */
    changeLineColor(statusCode) {
        this.line.setStyles('strokeColor', mapControl.LINE_COLOR[statusCode]);
    }
    /**
     * 최상위 위치
     */
    highlight() {
        this.setZIndex(this.highlight);
        if (this.line) {
            this.line.setZIndex(this.unhighlight);
        }
    }
    // 라인 추가
    addLine() {
        const { startLat, startLng, endLat, endLng, statusCode, isShow, } = this;
        const strokeColor = statusCode === 'PICKUP_FINISHED'
            ? '#6D4C41'
            : '#00A7FF';
        this.line = new this.naver.maps.Polyline({
            strokeColor,
            strokeWeight: 4,
            strokeOpacity: 0.8,
            strokeLineCap: 'round',
            path: [
                new this.naver.maps.LatLng(startLat, startLng),
                new this.naver.maps.LatLng(endLat, endLng),
            ],
            clickable: true,
            map: isShow ? this.mapInstance : null,
            isLine: true,
        });
    }
    /**
     * 도착지 위치 변경
     * @param {Object} _drop
     */
    updateDropPosition({ pickupLatitude, pickupLongitude, dropLatitude, dropLongitude, }) {
        const storePosition = {
            lat: pickupLatitude,
            lng: pickupLongitude,
        };
        const dropPosition = {
            lat: dropLatitude,
            lng: dropLongitude,
        };
        this.setPosition(dropPosition);
        this.line.setPath([
            storePosition,
            dropPosition,
        ]);
    }
    /**
     * 도착지 마커 데이터 업데이트 + 노출 / 비노출 / 제거
     * @param {boolean} orderData.isActive 활성화 여부
     * @param {boolean} orderData.isDelete 마커 제거 여부
     * @returns
     */
    updateMarker({ isActive: _isActive = null, } = {
        _isActive: null,
    }) {
        const orderData = this.mapControlState.orderList[this.orderId];
        const { statusCode } = orderData;
        this.isActive = typeof _isActive === 'boolean' ? _isActive : this.isActive;
        this.relatedWeight = this.getRelatedWeight();
        const isShow = this.computeIsShow(orderData);
        if (isShow) {
            this.changeLineColor(statusCode);
            this.setMap(this.mapInstance);
            this.line.setMap(this.mapInstance);
        }
        else {
            this.setMap(null);
            this.line.setMap(null);
        }
        // 아이콘 관련 로직
        const iconOptions = dropIcon({
            naver: this.naver,
            orderId: this.orderId,
            isActive: this.isActive,
            relatedWeight: this.relatedWeight,
            isDelayedState: this.isDelayedState,
        });
        this.setIcon(iconOptions);
        // @ts-ignore
        this.isLine = iconOptions.isLine;
    }
    /**
     * 주문 비노출 | 제거
     * @param _orderId 주문 아이디
     * @param isDeleteMarker 제거 여부
     */
    deactivateMarker(isDeleteMarker) {
        const { orderId } = this;
        const mkStore = this.getMyStore();
        const mkWorker = this.getAllocatedWorker();
        // 가중치
        this.mapMarkerList.updateOrderMarkerWeight(orderId, true);
        // 주문
        this.unhighlight();
        this.updateMarker({
            isActive: false,
        });
        if (isDeleteMarker) {
            this.deleteMarker();
        }
        // 상점
        mkStore.unhighlight();
        mkStore.updateMarker();
        // 워커. 주문 배차 라이더 연관 상태 업데이트
        if (mkWorker) {
            mkWorker.unhighlight();
            mkWorker.updateMarker();
        }
    }
    /**
     * 주문 가중치 제거
     * TODO: updateOrderMarkerWeight 차이 확인 필요
     */
    decreaseDropMarkerWeight() {
        const orderData = this.mapControlState.orderList[this.orderId];
        const { storeId, orderId, allocatedWorkerCode, isAccepted, } = orderData;
        this.mapMarkerList.updateOrderMarkerWeight(orderId, true);
        this.updateMarker();
        const mkStore = this.mapMarkerList.stores.getMarker(storeId);
        mkStore.updateMarker();
        if (!isAccepted) {
            const mkWorker = this.mapMarkerList.workers.getMarker(allocatedWorkerCode);
            mkWorker.updateMarker();
        }
    }
    /**
     * 도착지 활성 (제거 clearAllDropMarker)
     * 주문 가중치 추가, 도착지 노출, 주문의 상점 업데이트, 주문의 배차 라이더 업데이트
     * @param {String} _orderId 주문 아이디
     */
    activateMarker() {
        const orderData = this.mapControlState.orderList[this.orderId];
        const { orderId, storeId, isAccepted, allocatedWorkerCode, } = orderData;
        const mkStore = this.mapMarkerList.stores.getMarker(storeId);
        const mkWorker = this.mapMarkerList.workers.getMarker(allocatedWorkerCode);
        // 가중치
        this.mapMarkerList.updateOrderMarkerWeight(orderId);
        // 주문
        this.highlight();
        this.updateMarker({
            isActive: true,
        });
        // 상점
        mkStore.highlight();
        mkStore.updateMarker();
        // 워커
        // 접수가 아니면 === 배차 관련 로직
        if (!isAccepted && mkWorker) {
            mkWorker.highlight();
            mkWorker.updateMarker();
        }
    }
    /**
     * 노출, 비노출 연산
     * @param orderData 주문 객체
     * @returns true => show, false => hide
     */
    computeIsShow(orderData) {
        const { statusCode, isShareOrder, isAccepted, } = orderData;
        const relatedWeight = this.getRelatedWeight();
        const { mapVisibilitySetting: { isHideShareOrder, }, } = this.mapControlState;
        // 공유주문숨김 채크시 접수건 제외
        if (isShareOrder
            && isHideShareOrder
            && isAccepted) {
            return false;
        }
        // 가중치가 있다면 노출
        if (relatedWeight) {
            return true;
        }
        // 필터 채크는 가중치 있을 경우만 채크
        if (relatedWeight
            && isIncludedCurrentFilter(statusCode, this.hubControlMap.orderFilter)) {
            return true;
        }
        return false;
    }
    /**
     * 마커 노출 / 비노출 토글
     * @param {*} mapInstance
     * @returns
     */
    toggleVisibility(mapInstance = null) {
        // 숨길시에만 연관가중치, 활성여부 채크
        if (!mapInstance && (this.relatedWeight > 0 || this.isActive)) {
            return;
        }
        this.setMap(mapInstance);
        this.line.setMap(mapInstance);
    }
}
